/**
 * Transforms the user configured acceptance parsing steps Ring Tree Target Form
 * @param {*} parsing parsing object
 * @returns an array of parsing steps
 */
export function sanitizeAcceptanceParsingForRingTreeTargetForm(parsing) {
  const acceptanceParsing = [];

  parsing.forEach(item => {
    const { property, path, operator, value } = item;
    const requiresInteger = !isNaN(value) && (operator.value === '<' || operator.value === '>');
    const inputParsingValue = requiresInteger ? `return input.toLowerCase() ${operator.value} ${value}` : `return input.toLowerCase() ${operator.value} "${value}".toLowerCase()`;

    acceptanceParsing.push({
      'parserType': 'JPath',
      'value': (typeof property === 'object') ? property.path : path
    });

    acceptanceParsing.push({
      'parserType': 'JavaScript',
      'value': inputParsingValue
    });
  });

  return acceptanceParsing;
}

export function sanitizeRequestPropertyForRingTreeTargetForm(parsing) {
  const property = parsing[0].property;
  return [
    {
      'parserType': 'Jpath',
      'value': (typeof property === 'object') ? property.path : property,
    }
  ];
}
